import { cn, UserAvatar } from "@nexus/ui";

import { useAuth } from "@/features/auth/hooks/useAuth";

interface SentByIdentityProps {
  name: string;
  userId?: string | null;
  className?: string;
}

export function SentByIdentity({
  name,
  userId,
  className,
}: SentByIdentityProps) {
  const authUser = useAuth((state) => state.user);
  const photo =
    authUser &&
    (authUser.sub === userId || authUser.name?.trim() === name)
      ? authUser.picture
      : null;

  return (
    <span className={cn("flex min-w-0 items-center gap-1.5", className)}>
      <span aria-hidden className="shrink-0">
        <UserAvatar
          name={name}
          src={photo}
          size="sm"
          className="size-5 text-[9px] shrink-0"
        />
      </span>
      <span className="min-w-0 truncate">{name}</span>
    </span>
  );
}
